<template>
  <b-card
    style="height: 260px"
  >
    <b-card-title>
      <h3 class="text-center">
        Last Completed Trip
      </h3>
    </b-card-title>

    <h5 class="text-center mt-4">
      <b-spinner
        v-if="loading"
        variant="primary"
        class="text-center"
      />
      <div
        v-else
      >
        <div
          v-if="tripDetails.tripId"
          class="d-flex flex-column"
        >
          <b-link
            :to="{ path: `/trips/${tripDetails.tripId}` }"
          >
            {{ tripDetails.tripNumber }}
          </b-link>
          <span class="mt-2">{{ tripDetails.at | formatDate }}</span>
        </div>
        <span
          v-else
          class="mt-2"
        >No matching trip found</span>
      </div>
    </h5>

  </b-card>
</template>

<script>
import {
  BCard, BCardTitle, BLink, BSpinner,
} from 'bootstrap-vue'
import { reactive, ref } from '@vue/composition-api'

export default {
  components: {
    BCard,
    BCardTitle,
    BLink,
    BSpinner,
  },
  props: {
    userType: {
      type: String,
      default: '',
    },
  },
  setup(props, ctx) {
    const loading = ref(false)
    const personId = ctx.root.$route.query.externalId
    const tripDetails = reactive({
      tripNumber: null,
      tripId: null,
      at: null,
    })
    const queryParams = {
      size: 10,
      page: 1,
      user_id: props.userType === 'user' ? personId : undefined,
      driver_id: props.userType === 'driver' ? personId : undefined,
      state: 'COMPLETED',
    }
    const fetchLastCompletedTrip = async () => {
      try {
        loading.value = true
        const res = (await ctx.root.$store.dispatch('driverUsersTrips/fetchDriverUserTripsList', queryParams)).data.data
        tripDetails.tripNumber = res?.trips[0]?.number
        tripDetails.tripId = res?.trips[0]?.id
        tripDetails.at = res?.trips[0]?.createdAt
      } catch (error) {
        console.log(error)
      } finally {
        loading.value = false
      }
    }
    fetchLastCompletedTrip()

    return {
      tripDetails,
      loading,
    }
  },

}
</script>

<style>

</style>
